import { Modal, Container, Row, Col, ModalFooter } from 'react-bootstrap';
import React, { useState } from 'react';
import Button from '../../../components/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import Blockquote from '../../../components/Blockquote';

export type HSATransactionInformationModalProps = React.PropsWithChildren<{
  showModal: boolean;
  handleCloseModal: () => void;
  data?: any[];
}>;

const HSATransactionInformationModal = ({
  showModal,
  handleCloseModal,
  data,
}: HSATransactionInformationModalProps) => {
  const [confirmIsOpen, setConfirmOpened] = useState(false);
  const [augmentedData, setAugmentedData] = useState(data);
  const [idx, setIdx] = useState(0);

  const handleGetIdx = (index: number) => {
    setIdx((prev) => (prev = index));
  };

  const handleDeleteTransaction = (index: number) => {
    setAugmentedData(augmentedData?.filter((x, idx) => idx !== index));
  };

  const handleOpenConfirm = () => {
    setConfirmOpened((prev) => (prev = true));
  };

  const handleCloseConfirm = () => {
    setConfirmOpened((prev) => (prev = false));
  };

  const mainBody = (
    <>
      <Modal.Header className={'no-border'} closeButton>
        <h2 className={'text-sm-20-lg-32'}>HSA Transaction Information</h2>
      </Modal.Header>
      <Modal.Body>
        <Container className={'cnd-custom-container mt-11 mb-3'}>
          <Row className={'mt-10 mt-lg-0 overflow-auto'}>
            <Col className={'col-12'}>
              <Row style={{ width: 920 }}>
                <Col className={'d-flex flex-column d-lg-block flex-nowrap'}>
                  <Row
                    className={
                      'flex-nowrap px-8 px-lg-0 d-flex align-items-center border-bottom-dark-gray py-8'
                    }
                  >
                    <Col className={'col-4 text-fs-6 m-0'}>Date</Col>
                    <Col className={'col-3 ps-6 m-0 text-end'}>
                      <span className={'text-fs-6'}>Transaction</span>
                    </Col>
                    <Col className={'col-2 text-fs-6 m-0 text-center'}>
                      <span className={'text-fs-6'}>Amount</span>
                    </Col>
                    <Col className={'col-2 text-fs-6 m-0 text-center'}>
                      <span className={'text-fs-6'}>Status</span>
                    </Col>
                    <Col className={'col-2 text-fs-6 m-0 text-end'}></Col>
                  </Row>

                  {augmentedData?.map((transactionData, idx) => {
                    return (
                      <Row
                        className={
                          'flex-nowrap px-8 py-11 px-lg-0 py-lg-8 d-flex flex-lg-row align-items-center border-bottom border-info'
                        }
                      >
                        <Col className={'col-4'}>
                          <span className={'h3 text-fs-6 m-0'}>
                            {transactionData.date}
                          </span>
                        </Col>
                        <Col className={'col-3 text-end'}>
                          <span className={'h3 text-fs-6'}>
                            {transactionData.transaction}
                          </span>
                        </Col>
                        <Col className={'col-2 text-center'}>
                          <span className={'text-fs-6 fw-light'}>
                            {transactionData.amount}
                          </span>
                        </Col>
                        <Col className={'col-2 text-center'}>
                          <span className={'fw-light text-fs-6'}>
                            {transactionData.status}
                          </span>
                        </Col>
                        <Col className={'col-1 text-end text-blue'}>
                          <FontAwesomeIcon
                            onClick={() => {
                              handleOpenConfirm();
                              handleGetIdx(idx);
                            }}
                            className={'cursor-pointer'}
                            icon={light('trash-can')}
                          />
                        </Col>
                      </Row>
                    );
                  })}
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <ModalFooter>
        <Button onClick={handleCloseModal} variant={'primary-outline'}>
          Close
        </Button>
      </ModalFooter>
    </>
  );

  const confirmActionBody = (
    <>
      <Modal.Header className={'no-border pb-10'} closeButton>
        <Container className={'text-center px-0'}>
          <h2 className={'text-sm-16-lg-20 fw-normal mb-0'}>Confirm Action</h2>
        </Container>
      </Modal.Header>
      <Modal.Body className={'pt-0'}>
        <Container className={'text-center px-0 mb-10'}>
          <span className={'text-fs-6 fw-light mt-10'}>
            Are you sure you want to delete this HSA transaction? You can’t undo
            this action!
          </span>
        </Container>
        <Blockquote variant={'warning-bg'} lineVariant={'warning'}>
          <Container className={'px-0 d-flex flex-column'}>
            <span className={'text-fs-6 fw-bold text-danger-dark'}>
              Warning?
            </span>
            <span className={'text-fs-6 fw-light'}>
              If you delete this transaction, you will not be making a one-time
              contribution to your HSA.
            </span>
          </Container>
        </Blockquote>
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={() => {
            handleCloseConfirm();
          }}
          variant={'primary-outline'}
        >
          Cancel
        </Button>
        <Button
          className={'mb-7 mb-lg-0'}
          onClick={() => {
            handleDeleteTransaction(idx);
            handleCloseConfirm();
          }}
        >
          Proceed
        </Button>
      </Modal.Footer>
    </>
  );
  return (
    <Modal
      size={'xl'}
      onHide={() => {
        handleCloseModal();
        handleCloseConfirm();
      }}
      show={showModal}
    >
      {confirmIsOpen ? confirmActionBody : mainBody}
    </Modal>
  );
};

export default HSATransactionInformationModal;
